<template>
  <v-app>
    <template v-if="isLogin">
      <TheLoginHeader />
    </template>
    <template v-else-if="isGuest">
      <TheGuestHeader />
    </template>

    <v-content :class="{'content-bottom': isLogin}">
      <transition :name="$store.state.transitionMode">
        <router-view />
      </transition>
    </v-content>

    <template v-if="isLogin">
      <TheLoginFooter />
    </template>

    <AnnounceSnackbar />
    <ConfirmPartnerLink />
  </v-app>
</template>

<style>
.text-size-1 {
  font-size: 10px;
}
.text-size-2 {
  font-size: 12px;
}
.text-size-3 {
  font-size: 14px;
}
.text-size-4 {
  font-size: 16px;
}
.text-size-5 {
  font-size: 20px;
}
.text-size-6 {
  font-size: 24px;
}
.text-size-7 {
  font-size: 28px;
}

.content-bottom {
  margin-bottom: 80px;
}

.fade-enter {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
}
.fade-enter-active {
  transition: all 1s .2s ease;
}
.fade-leave {
  opacity: 1;
}
.fade-leave-to {
  opacity: 0;
}
.fade-leave-active {
  transition: all .2s 0s ease;
}

.move-enter {
  transform: translate(0, 50px);
  opacity: 0;
}
.move-enter-to {
  opacity: 1;
}
.move-enter-active {
  transition: all 1s 0s ease;
}
.move-leave {
  transform: translate(0, 0);
  opacity: 1;
}
.move-leave-to {
  transform: translate(0, -50px);
  opacity: 0;
}
.move-leave-active {
  transition: all .5s 0s ease;
}
</style>

<script>
import TheGuestHeader from './layouts/TheGuestHeader';
import TheLoginHeader from './layouts/TheLoginHeader';
import TheLoginFooter from './layouts/TheLoginFooter';

import AnnounceSnackbar from './components/Snackbars/AnnounceSnackbar';
import ConfirmPartnerLink from './components/Dialogs/ConfirmPartnerLinkDialog';

export default {
  name: 'App',
  components: {
    TheGuestHeader,
    TheLoginHeader,
    TheLoginFooter,
    AnnounceSnackbar,
    ConfirmPartnerLink,
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    isGuest() {
      return this.$store.state.isGuest;
    },
  },
  created: function() {
    document.title = process.env.VUE_APP_TITLE;
  },
};
</script>
